var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.$router.push(_vm.route)}}},[_vm._v("Back")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }